import { settingsService } from "@/services";
import type { OrgSettings } from "@/types/api";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { qk } from "./queryKeys";

export function useUpdateSettings() {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: (patch: {
			settings?: Omit<OrgSettings, "hostname" | "modules">;
			autoJoinDomains?: string[];
		}) => settingsService.update(patch),
		onSuccess: () => qc.invalidateQueries({ queryKey: qk.org }),
	});
}
